/* Note: this file is generated by "npm run template", please dont modify this file directly */
import { ResultDir } from "@gant-lowcode/lowcode-types";

import { createResultDir } from "../../../../../utils/resultHelper";
import { runFileGenerator } from "../../../../../utils/templateHelper";
import file0 from "./files/.editorconfig";
import file1 from "./files/.gitignore";
import file2 from "./files/.prettierignore";
import file3 from "./files/.prettierrc";
import file4 from "./files/.umirc.ts";
import file5 from "./files/package.json";
import file6 from "./files/pnpm-lock.yaml";
import file7 from "./files/README.md";
import file8 from "./files/tsconfig.json";
import file9 from "./files/typings.d.ts";

export function generateStaticFiles(root = createResultDir(".")): ResultDir {
  runFileGenerator(root, file0);
  runFileGenerator(root, file1);
  runFileGenerator(root, file2);
  runFileGenerator(root, file3);
  runFileGenerator(root, file4);
  runFileGenerator(root, file5);
  runFileGenerator(root, file6);
  runFileGenerator(root, file7);
  runFileGenerator(root, file8);
  runFileGenerator(root, file9);
  return root;
}
